// Reuse a single formatter instance to avoid repeated Intl.NumberFormat construction
const formatter = new Intl.NumberFormat("en", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const MoneyFormat = (value: number | string): string => {
  if (value === null || value === undefined) return "";
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (!Number.isFinite(n as number)) return "";
  return formatter.format(n as number);
};

export default MoneyFormat;
